import React, { Component } from "react";
import "./Projectsnew.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { projectsnew } from "../../portfolio";
import { Fade } from "react-reveal";

class ProjectNew extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="main" id="educations">
        <div className="educations-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="educations-header" style={{ color: theme.text }}>
              Projects
            </h1>
          </Fade>
        </div>
        <div className="educations-body-div">
          {projectsnew.degrees.map((degree) => {
            return <DegreeCard degree={degree} theme={theme} />;
          })}
        </div>
      </div>
    );
  }
}

export default ProjectNew;
